import React, { useEffect, useContext, useState } from 'react';
import { alpha, Checkbox, Container, InputBase, Menu, styled, TablePagination } from '@mui/material';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import SearchIcon from '@mui/icons-material/Search';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import apiService from '../../../api/apiService';
import { LoadingButton } from '@mui/lab';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import downloadExcel from '../../../hooks/downloadExcel';
import { Link } from 'react-router-dom';
import DataContext from '../../../context/DataContext';
import useDidMountEffect from '../../../hooks/useDidMountEffect';
import CustomLink from '../../common-page/CustomLink';

const SearchinputDiv = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    color: "black",
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '18ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));


const Adminassociated = ({ name, path, endpoint }) => {
    const { modalstyle, page, rowsPerPage, count, handleChangePage, handleChangeRowsPerPage } = useContext(DataContext)
    const [checkedList, setCheckedList] = useState([]);
    const [searchInputValue, setSearchInputValue] = useState("");
    useDidMountEffect(() => {
        (async () => await startuplistItem(name, endpoint))()
        // eslint-disable-next-line
    }, [page, rowsPerPage, searchInputValue, checkedList, name, path, endpoint,])
    const [startupListData, setStartupListData] = useState([]);
    const startuplistItem = async (name, endpoint) => {
        var req = {
            // "roleId": localStorage.getItem('regRoleId'),
            "listSize": rowsPerPage,
            "pageNumber": page + 1,
            "searchString": searchInputValue,
        };
        let method = "";
        if (name === "jury") {
            method = "post";
        } else {
            method = "get";
            await apiService(`${name}/${endpoint}/list`, req, method).then((res) => {
                if (res) {
                    if (res.data.startups) {
                        // setCount(res.data.count)
                        setStartupListData(res.data.startups);
                    } else {
                        setStartupListData([]);
                    }
                }
            });
        }
        await apiService(`${name}/${endpoint}/list`, req, method).then((res) => {
            if (res) {
                if (res.data.startups) {
                    // setCount(res.data.count)
                    setStartupListData(res.data.startups);
                } else {
                    setStartupListData([]);
                }
            }
        });
    };


    const handleSearch = (searchValue) => {
        setSearchInputValue(searchValue);
    };


    return (
        <section className=''>
            <div className='container-fluid'>
                <div className='form_div chart'>
                    <div className='header_tag'>
                        <h5>Associated Startups List</h5>
                    </div>
                    <div className='table_tag'>
                        {/* <div className='table_header_tag d-flex'>

                            <SearchinputDiv onChange={(e) => handleSearch(e.target.value)} >
                                <SearchIconWrapper>
                                    <SearchIcon />
                                </SearchIconWrapper>
                                <StyledInputBase
                                    value={searchInputValue}
                                    type="search"
                                    placeholder="Search for a Startup"
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </SearchinputDiv>


                        </div> */}
                        {
                            (startupListData.length) ? (
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="caption table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center'>No</TableCell>
                                                <TableCell>Startup Name</TableCell>
                                                <TableCell align='center'>Partner / Investor Name</TableCell>
                                                <TableCell align='center'>Selected</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {startupListData.map((list, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align='center'>{index + 1}</TableCell>
                                                    <TableCell>
                                                        <CustomLink to={`/admin/associated-startups/details/${btoa(list.startupId)}/${btoa(list.partnerOrInvestorId)}`}>{list.startupName}</CustomLink>

                                                        {/* {list.startupName} */}
                                                    </TableCell>
                                                    <TableCell align='center'>{list.partnerName}</TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            (list.selected === 1) ? (<div className='yes_span'>Yes</div>) : <></>
                                                        }
                                                        {
                                                            (list.selected === 2) ? (<div className='no_span'>No</div>) : <> </>
                                                        }
                                                        {
                                                            (list.selected === 0) ? (<div className='review_span'>Under Review</div>) : <></>
                                                        }
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        {/* <caption>
                                            <TablePagination
                                                component="div"
                                                count={count}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                style={{ float: 'left' }}
                                            /></caption> */}
                                    </Table>

                                </TableContainer>
                            ) : (
                                <div className='nodata_tag'>
                                    <img src='/images/Tanfundlogo-black-1.png' className='no_data_logo' alt='' />
                                    <h4>Startup Association Inprogress</h4>
                                </div>
                            )
                        }

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Adminassociated